"use strict";

var _classCallCheck = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Vector = void 0;

var Vector =
/*#__PURE__*/
function () {
  function Vector(x, y) {
    _classCallCheck(this, Vector);

    var defX, defY;

    if (y === undefined) {
      if (typeof x === "number") {
        throw new Error("tsParticles - Vector not initialized correctly");
      }

      var coords = x;
      var _ref = [coords.x, coords.y];
      defX = _ref[0];
      defY = _ref[1];
    } else {
      defX = x;
      defY = y;
    }

    this.x = defX;
    this.y = defY;
  }

  _createClass(Vector, [{
    key: "add",
    value: function add(v) {
      return Vector.create(this.x + v.x, this.y + v.y);
    }
  }, {
    key: "addTo",
    value: function addTo(v) {
      this.x += v.x;
      this.y += v.y;
    }
  }, {
    key: "sub",
    value: function sub(v) {
      return Vector.create(this.x - v.x, this.y - v.y);
    }
  }, {
    key: "subFrom",
    value: function subFrom(v) {
      this.x -= v.x;
      this.y -= v.y;
    }
  }, {
    key: "mult",
    value: function mult(n) {
      return Vector.create(this.x * n, this.y * n);
    }
  }, {
    key: "multTo",
    value: function multTo(n) {
      this.x *= n;
      this.y *= n;
    }
  }, {
    key: "div",
    value: function div(n) {
      return Vector.create(this.x / n, this.y / n);
    }
  }, {
    key: "divTo",
    value: function divTo(n) {
      this.x /= n;
      this.y /= n;
    }
  }, {
    key: "distanceTo",
    value: function distanceTo(v) {
      return this.sub(v).length;
    }
  }, {
    key: "getLengthSq",
    value: function getLengthSq() {
      return Math.pow(this.x, 2) + Math.pow(this.y, 2);
    }
  }, {
    key: "distanceToSq",
    value: function distanceToSq(v) {
      return this.sub(v).getLengthSq();
    }
  }, {
    key: "manhattanDistanceTo",
    value: function manhattanDistanceTo(v) {
      return Math.abs(v.x - this.x) + Math.abs(v.y - this.y);
    }
  }, {
    key: "copy",
    value: function copy() {
      return Vector.clone(this);
    }
  }, {
    key: "setTo",
    value: function setTo(velocity) {
      this.x = velocity.x;
      this.y = velocity.y;
    }
  }, {
    key: "rotate",
    value: function rotate(angle) {
      return Vector.create(this.x * Math.cos(angle) - this.y * Math.sin(angle), this.x * Math.sin(angle) + this.y * Math.cos(angle));
    }
  }, {
    key: "updateFromAngle",
    value: function updateFromAngle(angle, length) {
      this.x = Math.cos(angle) * length;
      this.y = Math.sin(angle) * length;
    }
  }, {
    key: "angle",
    get: function get() {
      return Math.atan2(this.y, this.x);
    },
    set: function set(angle) {
      this.updateFromAngle(angle, this.length);
    }
  }, {
    key: "length",
    get: function get() {
      return Math.sqrt(Math.pow(this.x, 2) + Math.pow(this.y, 2));
    },
    set: function set(length) {
      this.updateFromAngle(this.angle, length);
    }
  }], [{
    key: "clone",
    value: function clone(source) {
      return Vector.create(source.x, source.y);
    }
  }, {
    key: "create",
    value: function create(x, y) {
      return new Vector(x, y);
    }
  }, {
    key: "origin",
    get: function get() {
      return Vector.create(0, 0);
    }
  }]);

  return Vector;
}();

exports.Vector = Vector;